import _ from 'underscore';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { stringKeyToTuple, tupleToStringKey } from 'js/lib/stringKeyTuple';
import user from 'js/lib/user';
import { isOutsourcing } from 'js/utils/emailOutsourcingUtils';

import Naptime from 'bundles/naptimejs';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumStatisticsV1 from 'bundles/naptimejs/resources/groupForumStatistics.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumStatisticsV1 from 'bundles/naptimejs/resources/onDemandCourseForumStatistics.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';

/**
 * Provides the following props:
 * {
 *   courseForums: React.PropTypes.arrayOf(React.PropTypes.instanceOf(OnDemandCourseForumsV1)),
 *   mentorForums: React.PropTypes.arrayOf(React.PropTypes.instanceOf(OnDemandMentorForumsV1)),
 *   groupForums: React.PropTypes.arrayOf(React.PropTypes.instanceOf(GroupForumsv1)),
 *   courseId: React.PropTypes.string,
 *   hasModerationRole: React.PropTypes.bool,
 *   courseSlug: React.PropTypes.string,
 *   userId: React.PropTypes.number,
 *   overrideBranchId: React.PropTypes.string,
 *   courseForumStatistics: React.PropTypes.arrayOf(React.PropTypes.instanceOf(OnDemandCourseForumStatisticsesV1)),
 *   groupForumStatistics: React.PropTypes.arrayOf(React.PropTypes.instanceOf(GroupForumStatisticsV1)),
 * }
 */
export default ({ fields, subcomponents }: { fields?: string[]; subcomponents?: string[] } = {}) =>
  _.compose(
    connectToStores(
      ['CourseStore', 'CourseMembershipStore', 'ApplicationStore', 'SessionFilterStore'],
      ({ CourseStore, CourseMembershipStore, ApplicationStore, SessionFilterStore }) => ({
        courseId: CourseStore.getCourseId(),
        courseSlug: CourseStore.getCourseSlug(),
        hasModerationRole:
          CourseMembershipStore.hasModerationRole() || ApplicationStore.isSuperuser() || isOutsourcing(user),
        overrideBranchId: SessionFilterStore.overrideBranchId,
        selectedSession: SessionFilterStore.selectedSession,
        filterQueryString: SessionFilterStore.activeFilterQueryString,
        userId: ApplicationStore.getUserData().id,
      })
    ),
    Naptime.createContainer((props) => {
      // if hasModerationRole is undefined, we are in the naptime connector - and we want to enable mentor forums so that
      // fields are processed correctly
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModerationRole' does not exist on typ... Remove this comment to see the full error message
      const hasModerationRole = props.hasModerationRole !== false;

      return {
        courseForums: OnDemandCourseForumsV1.course({
          params: {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type '{}'.
            courseId: props.courseId,
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'overrideBranchId' does not exist on type... Remove this comment to see the full error message
            overrideBranchId: props.overrideBranchId,
          },
          fields: ['title', 'description', 'parentForumId'],
        }),
        mentorForums: !hasModerationRole
          ? []
          : OnDemandMentorForumsV1.course({
              params: {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type '{}'.
                courseId: props.courseId,
              },
              fields: ['title', 'description', 'parentForumId'],
            }),
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
        groupForums: props.selectedSession
          ? GroupForumsV1.courseAndSession({
              params: {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type '{}'.
                courseId: props.courseId,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'selectedSession' does not exist on type ... Remove this comment to see the full error message
                sessionId: props.selectedSession,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type '{}'.
                userId: props.userId,
              },
              fields: ['title', 'description', 'parentForumId'],
            })
          : GroupForumsV1.course({
              params: {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type '{}'.
                courseId: props.courseId,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'userId' does not exist on type '{}'.
                userId: props.userId,
              },
              fields: ['title', 'description', 'parentForumId'],
            }),
      };
    }),
    // Gets statistics for courseForums and groupForums. This loads lazily because this is a relatively slow API.
    Naptime.createContainer((props) => {
      let courseForumStatistics = [];
      let groupForumStatistics = [];

      // Gets statistics for courseForums
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseForums' does not exist on type '{}... Remove this comment to see the full error message
      if (props.courseForums && props.courseForums.length > 0 && (props.filterQueryString || props.isCourseWeekPage)) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseForums' does not exist on type '{}... Remove this comment to see the full error message
        const rootForum = props.courseForums.find((forum) => !forum.parentForumId);
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'isCourseWeekPage' does not exist on type... Remove this comment to see the full error message
        const filterQuery = props.isCourseWeekPage ? 'all' : props.filterQueryString;
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseForums' does not exist on type '{}... Remove this comment to see the full error message
        const topLevelCourseForums = props.courseForums.filter((forum) => forum.parentForumId === rootForum.id);
        const topLevelCourseForumIds = topLevelCourseForums.map((forum: $TSFixMe) =>
          tupleToStringKey([forum.id, filterQuery])
        );

        courseForumStatistics = OnDemandCourseForumStatisticsV1.multiGet(
          topLevelCourseForumIds,
          {
            fields: ['forumQuestionCount', 'lastAnsweredAt'],
            required: false,
          },
          // data processor: strip off the filterQueryString for the courseForumId
          (statistics: $TSFixMe) =>
            statistics.map((statistic: $TSFixMe) => {
              if (statistic.courseForumId) {
                return statistic;
              }

              const courseForumId = stringKeyToTuple(statistic.id)[0];
              return Object.assign(statistic, { courseForumId });
            })
        );
      }

      // Gets statistics for groupForums
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'groupForums' does not exist on type '{}'... Remove this comment to see the full error message
      if (props.groupForums && props.groupForums.length > 0) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'groupForums' does not exist on type '{}'... Remove this comment to see the full error message
        const groupForumIds = props.groupForums.map((forum) => forum.id);

        groupForumStatistics = GroupForumStatisticsV1.multiGet(groupForumIds, {
          fields: ['forumQuestionCount', 'lastAnsweredAt'],
          required: false,
        });
      }

      return {
        courseForumStatistics,
        groupForumStatistics,
      };
    })
  );
